




import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../boot/index";
import axios from "axios";

// get inventory
export const getInvoices = createAsyncThunk("invoices/getlist-invoice", async (data) => {
    const token = localStorage.getItem("authToken")
    try {
        const response = await axios.get(`${baseUrl}cleaningappfunctions/finance/app/v1/getlist-invoice`, data, { 
            headers: {
                "auth-token": token,
            }
        },);
        console.log({ response })
        return response;
    } catch (error) {
        console.error('Error fetching invoices - ', error);
        throw error;
    }
})


